export const KEYCODES = {
  escape: 27,
  arrowLeft: 37,
  arrowRight: 39,
};
